export default __webpack_public_path__ + "static/media/scroll-gif.2984070f.gif";